import React from 'react';
import ErrorAltCloseIcon from '../assets/images/ErrorAltClose.svg';

export default () => {
    return <img src={ErrorAltCloseIcon} alt="" />;
  };
  